import { MetaReducer, Action, provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { createLocalStorageSyncReducer } from '../../shared/utils/local-storage-sync';
import { MetadataMgmtReducer, MetadataMgmtState } from './state/reducers/metadata-mgmt.reducer';
import { metaDataMgmtStateKey } from './state';
import { MetadataMgmtEffects } from './state/effects/metadata-mgmt.effects';
import { MetadataMgmtFacade } from './facade/metadata-mgmt.facade';
import { MetadataMgmtService } from './service/metadata-mgmt.service';

const localStorageSyncReducer = createLocalStorageSyncReducer<MetadataMgmtState>(['metadataMgmt']);

const metaReducers: Array<MetaReducer<MetadataMgmtState, Action>> = [localStorageSyncReducer];

export const metadataMgmtConfig = [
  provideState(metaDataMgmtStateKey, MetadataMgmtReducer, { metaReducers }),
  provideEffects([MetadataMgmtEffects]),
  MetadataMgmtFacade,
  MetadataMgmtService,
];
